const defineStringReplaceAll = () => {
  if (typeof String.prototype.replaceAll !== 'function') {
    String.prototype.replaceAll = function (
      searchValue: string | RegExp,
      replaceValue: string | ((substring: string, ...args: unknown[]) => string),
    ) {
      if (typeof replaceValue === 'function') {
        throw new Error('String.prototype.replaceAll function is not supported');
      }

      if (searchValue instanceof RegExp) {
        return this.replace(searchValue, replaceValue);
      }

      return this.replace(new RegExp(searchValue, 'g'), replaceValue);
    };
  }
};

export const polyFill = () => {
  defineStringReplaceAll();
};
